/**
 * Equipment and inventory constants
 */

/**
 * Official rule: Maximum consumables per subtype
 * This is a soft limit - users can exceed it for homebrew/house rules
 * UI shows informational tooltip when exceeded
 */
export const MAX_CONSUMABLE_HOLD = 5;
